import { getUrlConfig } from './url.config';
import { IEnvironment } from './types';
import packageJson from '../../package.json';

const BASE_URL = 'https://europe-west1-ihub-projects-production.cloudfunctions.net';

export const productionEnvironment: IEnvironment = {
  ...getUrlConfig(BASE_URL),
  GOOGLE_AUTH_SERVICE_ID: '587217239273-54r5bolic0udgeq9k3lcf4mubmnlklf8.apps.googleusercontent.com',
  API_KEY: 'AIzaSyAJAaYzbt9c402pV69iw8ra3dYckiD5GBI',
  VIDEOCHAT_LINK: 'videochat-32-128.mindlyspace.com',
  AMPLITUDE_API_KEY: '60a4fa14c093b4f11bed537d09dda0a3',
  INTERCOM: {
    APP_ID: 'isk9oqqt',
  },
  AGORA: {
    appID: '6fdcb7df6b8d447d8ecfca999ef6b7c8',
  },
  REMOTE_CONFIG: {
    FETCH_INTERVAL_IN_SECONDS: 3600,
    DEFAULT_VALUES: {
      apple_pay_enabled: false,
      google_pay_enabled: false,
      is_supported_app_versions_feature_enabled: true,
      is_stream_chat_enabled: true,
      client_apps_flyer_one_link_enabled_specialists: '',
      client_apps_flyer_one_link_enabled_onboarding: '',
      is_nps_interview_enabled: true,
      is_nps_interview_new: true,
      SUPPORTED_APP_VERSIONS: JSON.stringify({
        [packageJson['api-version']]: {},
      }),
    },
  },
  FIREBASE_CONFIG: {
    apiKey: 'AIzaSyB8cUDkOLdAXWud_Rb-1nKbXk0NyRX0MYo',
    authDomain: import.meta.env?.VITE_AUTH_DOMAIN ?? 'app.mindlyspsace.com',
    projectId: 'ihub-projects-production',
    storageBucket: 'ihub-projects-production.appspot.com',
    messagingSenderId: '587217239273',
    appId: '1:587217239273:web:416024417a5241127b0478',
    measurementId: 'G-5P8QJV9YB0',
  },
  STRIPE_PUBLIC_KEY:
    'pk_live_51IOrXcFWv7aoM10Uw4pjmExf2RbhIFM6oGBuqhE7hct4NY7sHMNWnXOkREetO8g7pUF2O14khQtnDO8Cyv6CL3cK00Lzb26I4C',
  DEEP_LINK: 'https://mindly.page.link/',
  APPS_FLYER_ONE_LINK: 'https://mindlyspace.onelink.me/SyFA',
  FB_PIXEL_ID: '512758471007527',
  TIK_TOK_PIXEL_ID: 'D05LSHBC77UF1HSAIM1G',
  MAIN_WEB_URL: 'https://app.mindlyspace.com',
  WEBSITE_URL: 'https://mindlyspace.com',
  APPLE_PAY_MERCHANT_ID: 'merchant.com.mindly',
  STREAM_API_TOKEN: '53hb24u7renc',

  JITSI_APP_ID: 'vpaas-magic-cookie-b157367e1efa48ceae44d6842caa9336',
};
